<template>
    <div>
        <div class="section">
            <div class="container">
                <a href="/"><img class="logo" src="https://firebasestorage.googleapis.com/v0/b/hiddenvillagecreations-51e08.appspot.com/o/hvclogo.png?alt=media" width="80"></a><br>
                <p class="is-size-7 is-italic	has-text-white">Glass Novelties, Jewellery, Custom Glass, Sublimation, Laser Art,</p> 
                <p class="is-size-7 is-italic	has-text-white">Cremation Memorials, Kelowna Souvenirs, Gold Panning Tours</p><br>
                <a class="button is-primary is-rounded" href="mailto:kelownaglassworks@gmail.com?Subject=Custom%20Order"><font-awesome-icon :icon="['fas', 'envelope']" size="lg" class="icon-margin"/>Contact Us</a><br><br>
                <a class="button is-primary is-rounded" @click="goToShop"><font-awesome-icon :icon="['fab', 'shopify']" size="lg" class="icon-margin"/>Online Shop</a><br><br>
                <a class="button is-primary is-rounded" @click="goInstagram"><font-awesome-icon :icon="['fab', 'instagram']" size="lg" class="icon-margin"/>@hiddenvillagecreations</a><br><br>
                <a class="button is-primary is-rounded" @click="goYoutube"><font-awesome-icon :icon="['fab', 'youtube']" size="lg" class="icon-margin"/>The Gold Panner</a><br><br>
                <a class="button is-primary is-rounded" @click="goWebsite"><font-awesome-icon :icon="['fas', 'globe']" size="lg" class="icon-margin"/>Hidden Village Creations Home</a><br><br>
                <a class="button is-primary is-rounded" @click="goFacebook"><font-awesome-icon :icon="['fab', 'facebook']" size="lg" class="icon-margin"/>MikeAstralHVC</a><br><br>
                <a class="button is-primary is-rounded" @click="goToPanningTour"><font-awesome-icon :icon="['fas', 'mountain']" class="icon-margin"/>Gold Panning Tours</a>
                <footer class="footer">
                <div class="content has-text-centered">  
                <p style="font-size:10px;">{{ new Date().getFullYear() }}  &copy; HiddenVillageCreations</p>
                </div>
            </footer>
            </div>
        </div>
    </div>
</template>

<script>
export default {
  name: 'link',
  methods: {
    goFacebook() {
      window.open("https://www.facebook.com/MikeAstralHVC", '_blank');
    },
    goInstagram() {
      window.open("https://www.instagram.com/hiddenvillagecreations", '_blank');
    },
    goYoutube() {
      window.open("https://www.youtube.com/channel/UCnhslU8Yp8HBUvJDaWGlNIw", '_blank');
    },
    goToPanningTour() {
      window.open("https://www.viator.com/tours/Kelowna-and-Okanagan-Valley/The-Best-Gold-Panning-at-Mission-Creek/d22366-418211P1?mcid=61846", '_blank');
    },
    goWebsite() {
        window.open("https://hiddenvillagecreations.com");
    },
    goToShop() {
      window.open("https://shop.hiddenvillagecreations.com/", '_blank');
    }
  }
}
</script>